import React, { useEffect, useRef } from 'react';

const amenities = [
  { icon: '🛗', label: 'Lift', desc: 'Convenient elevator access to all floors' },
  { icon: '🚗', label: 'Free Parking', desc: 'Secure on-premises parking for guests' },
  { icon: '📶', label: 'Free WiFi', desc: 'High-speed internet throughout the property' },
  { icon: '🚿', label: 'Hot Geyser', desc: 'Hot water available round the clock' },
  { icon: '❄️', label: 'AC Rooms', desc: 'Fully air-conditioned superior rooms' },
];

export default function Amenities() {
  const ref = useRef(null);
  useEffect(() => {
    if (!ref.current) return;
    ref.current.style.opacity = '0';
    const obs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) {
        e.target.style.transition = 'opacity 1s ease';
        e.target.style.opacity = '1';
        e.target.querySelectorAll('.amen-item').forEach((el, i) => {
          el.style.transitionDelay = `${i * 0.1}s`;
          el.style.opacity = '0';
          el.style.transform = 'translateY(20px)';
          setTimeout(() => {
            el.style.transition = 'opacity .7s ease, transform .7s ease';
            el.style.opacity = '1';
            el.style.transform = 'none';
          }, 200 + i * 100);
        });
      }
    }, { threshold: 0.1 });
    obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);

  return (
    <>
      <style>{`
        .amen-item { transition: background .3s, transform .3s !important; }
        .amen-item:hover { background: rgba(201,168,76,0.12) !important; transform: translateY(-3px) !important; }
        @media(max-width:860px){
          .amen-grid { grid-template-columns: repeat(3,1fr) !important; }
          .amen-item:nth-child(3) { border-right: none !important; }
          .amen-item:nth-child(4), .amen-item:nth-child(5) {
            border-top: 1px solid rgba(27,47,110,0.1) !important;
          }
        }
      `}</style>

      <section id="amenities" style={{ padding: '7rem 3rem', background: '#1B2F6E' }}>
        <div style={{ maxWidth: '1100px', margin: '0 auto' }}>
          {/* Header */}
          <div style={{ textAlign: 'center', marginBottom: '3.5rem' }}>
            <div style={{ display:'flex', alignItems:'center', gap:'.8rem', justifyContent:'center', marginBottom:'1rem' }}>
              <div style={{ width:'32px', height:'1px', background:'#C9A84C' }}/>
              <div style={{ width:'5px', height:'5px', background:'#C9A84C', transform:'rotate(45deg)' }}/>
              <div style={{ width:'32px', height:'1px', background:'#C9A84C' }}/>
            </div>
            <p style={{ fontFamily:"'Jost',sans-serif", fontSize:'.58rem', letterSpacing:'5px',
              textTransform:'uppercase', color:'#C9A84C', marginBottom:'.7rem', fontWeight:300 }}>
              Facilities
            </p>
            <h2 style={{ fontFamily:"'Cinzel',serif", fontSize:'clamp(1.9rem,4vw,2.9rem)',
              fontWeight:500, color:'#F2E8D9', marginBottom:'.3rem' }}>
              Every Comfort
            </h2>
            <h3 style={{ fontFamily:"'Cormorant',serif", fontSize:'clamp(1.3rem,3vw,2rem)',
              fontStyle:'italic', fontWeight:400, color:'#C9A84C' }}>
              provided for you
            </h3>
          </div>

          {/* Grid */}
          <div ref={ref} className="amen-grid" style={{
            display: 'grid', gridTemplateColumns: 'repeat(5,1fr)',
            border: '1px solid rgba(201,168,76,0.2)',
          }}>
            {amenities.map((a, i) => (
              <div key={a.label} className="amen-item" style={{
                padding: '3rem 1.5rem', textAlign: 'center',
                borderRight: i < 4 ? '1px solid rgba(201,168,76,0.2)' : 'none',
              }}>
                <div style={{ fontSize: '2.4rem', marginBottom: '1rem' }}>{a.icon}</div>
                <div style={{ fontFamily:"'Cinzel',serif", fontSize:'.72rem', letterSpacing:'2px',
                  color:'#F2E8D9', marginBottom:'.5rem', fontWeight:400 }}>{a.label}</div>
                <div style={{ fontFamily:"'EB Garamond',serif", fontSize:'.85rem', lineHeight:1.7,
                  color:'rgba(242,232,217,0.45)', fontStyle:'italic' }}>{a.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
